import { Flex } from "../../components/Flex";
import { Paragraph } from "../../components/Paragraph";
import { Box } from "../../components/Box";
import { DetailField } from "../../components/DetailField";
import CustomTabs from "../../components/CustomTabs";
import Employment from "./Employment";
import SourceOfFundsCard from "./SourceOfFunds";
import { ApplicationForms } from "./ApplicationForms";
import { Geolocation } from "../../components/Geolocation";
import { capitalise } from "../../utils/string";
import { DateTime } from "luxon";
import {
  Heading,
  TitleHeading,
  CardLine,
  isProvided,
  formatAddressDate,
  joinAddressParts,
} from "./styles";

export const PersonOverviewTab = ({
  individual,
  setShowAddNewForm,
}: {
  individual: any;
  setShowAddNewForm: (value: boolean) => void;
}) => {
  return (
                          <CustomTabs
                            variant="segmented"
                            tabs={[
                              {
                                label: "Invite",
                                content: (
                                  <div>
                                    <TitleHeading mb={2}>
                                      Invite Details
                                    </TitleHeading>
                                    <Flex gap="24">
                                      <DetailField
                                        flex={1}
                                        label="Title"
                                        value={individual?.title}
                                      />
                                      <DetailField
                                        flex={1}
                                        label="First name"
                                        value={individual?.first_name}
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Middle name"
                                        value={individual?.middle_name}
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Last name"
                                        value={individual?.last_name}
                                      />
                                    </Flex>
                                    <Flex gap="24" mt={2}>
                                      <DetailField
                                        flex={1}
                                        label="Gender"
                                        value={
                                          individual?.gender
                                            ? capitalise(individual?.gender)
                                            : undefined
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Date of birth"
                                        value={
                                          individual?.date_of_birth
                                            ? DateTime.fromISO(
                                                individual?.date_of_birth,
                                              ).toFormat("dd/MM/yyyy")
                                            : undefined
                                        }
                                      />
                                      <Box flex={1}></Box>
                                      <Box flex={1}></Box>
                                    </Flex>
                                  </div>
                                ),
                              },
                              {
                                label: "Personal",
                                content: (
                                  <div>
                                    <TitleHeading mb={2}>
                                      Personal Details
                                    </TitleHeading>

                                    <Flex gap="24">
                                      <DetailField
                                        flex={1}
                                        label="First name"
                                        value={
                                          individual?.personal_detail
                                            ?.first_name
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Middle name"
                                        value={
                                          individual?.personal_detail
                                            ?.middle_name
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Last name"
                                        value={
                                          individual?.personal_detail?.last_name
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Gender"
                                        value={
                                          individual?.personal_detail?.gender
                                            ? capitalise(
                                                individual?.personal_detail
                                                  ?.gender,
                                              )
                                            : undefined
                                        }
                                      />
                                    </Flex>
                                    <Flex gap="24" mt={2}>
                                      <DetailField
                                        flex={1}
                                        label="Date of birth"
                                        value={
                                          individual?.personal_detail
                                            ?.date_of_birth
                                            ? DateTime.fromISO(
                                                individual?.personal_detail
                                                  ?.date_of_birth,
                                              ).toFormat("dd/MM/yyyy")
                                            : undefined
                                        }
                                      />
                                    </Flex>
                                    <Flex gap="24">
                                      <Box flex={1} paddingTop={2}>
                                        <Heading mb={2}>Former Name</Heading>
                                        <Flex
                                          gap="24"
                                          fontSize={1}
                                          color="gray.60"
                                          fontFamily={"'Inter', sans-serif"}
                                        >
                                          {individual?.former_name?.length ? (
                                            individual?.former_name?.map(
                                              (
                                                {
                                                  first_name,
                                                  last_name,
                                                  middle_name,
                                                  change_date,
                                                },
                                                i,
                                              ) => (
                                                <Box flex={1} mb={2} key={i}>
                                                  <CardLine>
                                                    {first_name} {middle_name}{" "}
                                                    {last_name}
                                                  </CardLine>
                                                  <Heading>
                                                    {change_date && (
                                                      <CardLine color="gray.40">
                                                        From{" "}
                                                        {change_date
                                                          ? DateTime.fromISO(
                                                              change_date,
                                                            ).toFormat(
                                                              "dd/MM/yyyy",
                                                            )
                                                          : "-"}
                                                      </CardLine>
                                                    )}
                                                  </Heading>
                                                </Box>
                                              ),
                                            )
                                          ) : (
                                            <CardLine>
                                              No former names provided.
                                            </CardLine>
                                          )}

                                          {individual?.former_name?.length ===
                                            2 && (
                                            <>
                                              <Box flex={1} mb={2}></Box>
                                              <Box flex={1} mb={2}></Box>
                                            </>
                                          )}
                                          {individual?.former_name?.length ===
                                            3 && <Box flex={1} mb={2}></Box>}
                                        </Flex>
                                      </Box>
                                    </Flex>
                                    <Flex gap="24" mt={"2"}>
                                      {individual?.place_of_birth &&
                                        (individual?.place_of_birth?.country ||
                                          individual.place_of_birth?.city) && (
                                          <Box flex={1.4}>
                                            <Heading>Place of Birth</Heading>
                                            {individual?.place_of_birth ? (
                                              <Flex gap="24" mt={1}>
                                                <DetailField
                                                  flex={1}
                                                  label="Country"
                                                  value={
                                                    individual?.place_of_birth
                                                      ?.country
                                                  }
                                                />
                                                <DetailField
                                                  flex={1}
                                                  label="City"
                                                  value={
                                                    individual?.place_of_birth
                                                      ?.city
                                                  }
                                                />
                                                <Box flex={1}></Box>
                                                <Box flex={1}></Box>
                                              </Flex>
                                            ) : (
                                              "-"
                                            )}
                                          </Box>
                                        )}
                                    </Flex>
                                    {individual?.nationality?.length > 0 && (
                                      <Flex gap="24">
                                        <Box flex={1} paddingTop={2}>
                                          <Heading mb={2}>Nationality</Heading>
                                          <Flex
                                            gap="24"
                                            fontSize={1}
                                            color="gray.60"
                                            fontFamily={"'Inter', sans-serif"}
                                          >
                                            {individual?.nationality?.length
                                              ? individual?.nationality?.map(
                                                  (
                                                    { icon, nationality },
                                                    i,
                                                  ) => (
                                                    <Box
                                                      flex={1}
                                                      key={i}
                                                      mb={2}
                                                    >
                                                      {icon && (
                                                        <Box
                                                          backgroundColor={
                                                            "gray.10"
                                                          }
                                                          borderRadius={"50%"}
                                                          p={"1"}
                                                        >
                                                          <img
                                                            src={`data:image/png;base64,${icon}`}
                                                            alt="iamge"
                                                          />
                                                        </Box>
                                                      )}
                                                      {nationality && (
                                                        <>
                                                          &nbsp;
                                                          {nationality}
                                                        </>
                                                      )}
                                                    </Box>
                                                  ),
                                                )
                                              : "-"}

                                            {individual?.nationality?.length ===
                                              2 && (
                                              <>
                                                <Box flex={1} mb={2}></Box>
                                                <Box flex={1} mb={2}></Box>
                                              </>
                                            )}
                                            {individual?.nationality?.length ===
                                              3 && <Box flex={1} mb={2}></Box>}
                                          </Flex>
                                        </Box>
                                      </Flex>
                                    )}
                                  </div>
                                ),
                              },
                              {
                                label: "Address",
                                content: (
                                  <div>
                                    <Flex gap="24">
                                      <Box flex={1}>
                                        {individual?.address && (
                                          <Box mb={2}>
                                            <TitleHeading>Address</TitleHeading>
                                            {individual?.address ? (
                                              <>
                                                <Flex gap="24">
                                                  <Box flex={1}>
                                                    <CardLine>
                                                      {joinAddressParts([
                                                        individual?.address
                                                          ?.flat_appartment_subbuilding,
                                                        individual?.address
                                                          ?.building_number,
                                                        individual?.address
                                                          ?.building_name,
                                                        individual?.address
                                                          ?.road_street,
                                                      ])}
                                                    </CardLine>
                                                    <CardLine>
                                                      {joinAddressParts([
                                                        individual?.address
                                                          ?.town_city,
                                                        individual?.address
                                                          ?.district,
                                                      ])}
                                                    </CardLine>
                                                    <CardLine>
                                                      {isProvided(
                                                        individual?.address
                                                          ?.post_zip_code,
                                                      )
                                                        ? individual?.address
                                                            ?.post_zip_code
                                                        : "Not provided"}
                                                    </CardLine>
                                                  </Box>
                                                  <Box flex={1}>
                                                    <Flex
                                                      gap="8"
                                                      alignItems={"center"}
                                                      mb={1}
                                                      fontSize={1}
                                                      color="gray.60"
                                                      fontFamily={
                                                        "'Inter', sans-serif"
                                                      }
                                                    >
                                                      {individual?.address
                                                        ?.country_flag && (
                                                        <Box
                                                          backgroundColor={
                                                            "gray.10"
                                                          }
                                                          borderRadius={"50%"}
                                                          p={"1"}
                                                        >
                                                          <img
                                                            src={`data:image/png;base64,${individual?.address?.country_flag}`}
                                                            alt="iamge"
                                                          />
                                                        </Box>
                                                      )}
                                                      {isProvided(
                                                        individual?.address
                                                          ?.country_name,
                                                      ) && (
                                                        <span>
                                                          &nbsp;
                                                          {
                                                            individual?.address
                                                              ?.country_name
                                                          }
                                                        </span>
                                                      )}
                                                    </Flex>
                                                  </Box>
                                                  <Box flex={1}>
                                                    {isProvided(
                                                      individual?.address
                                                        ?.date_from,
                                                    ) && (
                                                      <Box p={"1"}>
                                                        <CardLine>
                                                          From &nbsp;
                                                          {formatAddressDate(
                                                            individual?.address
                                                              ?.date_from,
                                                          )}
                                                          {isProvided(
                                                            individual?.address
                                                              ?.date_to,
                                                          ) && (
                                                            <>
                                                              &nbsp; to &nbsp;{" "}
                                                              {formatAddressDate(
                                                                individual
                                                                  ?.address
                                                                  ?.date_to,
                                                              )}
                                                            </>
                                                          )}
                                                        </CardLine>
                                                      </Box>
                                                    )}
                                                  </Box>
                                                  <Box flex={1}></Box>
                                                </Flex>
                                              </>
                                            ) : (
                                              "-"
                                            )}
                                          </Box>
                                        )}

                                        {individual?.previous_address && (
                                          <Box mb={2}>
                                            <Heading>
                                              Previous Addresses
                                            </Heading>
                                            {individual?.previous_address &&
                                            individual?.previous_address
                                              ?.length > 0 ? (
                                              <>
                                                {individual?.previous_address?.map(
                                                  (prevAddress, i) => (
                                                    <Box key={i}>
                                                      <Heading
                                                        style={{ fontSize: 14 }}
                                                      >
                                                        Previous Address {i + 1}
                                                      </Heading>
                                                      <Flex gap="24">
                                                        <Box mb={2} flex={1}>
                                                          <CardLine>
                                                            {prevAddress?.flat_appartment_subbuilding && (
                                                              <span>
                                                                {
                                                                  prevAddress?.flat_appartment_subbuilding
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {prevAddress?.building_number && (
                                                              <span>
                                                                {
                                                                  prevAddress?.building_number
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {prevAddress?.building_name && (
                                                              <span>
                                                                {
                                                                  prevAddress?.building_name
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {
                                                              prevAddress?.road_street
                                                            }
                                                          </CardLine>

                                                          <CardLine>
                                                            {prevAddress?.town_city && (
                                                              <span>
                                                                {
                                                                  prevAddress?.town_city
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {
                                                              prevAddress?.district
                                                            }
                                                            ,{" "}
                                                            {
                                                              prevAddress?.post_zip_code
                                                            }
                                                          </CardLine>

                                                          <CardLine>
                                                            {DateTime.fromISO(
                                                              prevAddress?.date_from,
                                                            ).toFormat(
                                                              "dd/MM/yyyy",
                                                            )}{" "}
                                                            -{" "}
                                                            {DateTime.fromISO(
                                                              prevAddress?.date_to,
                                                            ).toFormat(
                                                              "dd/MM/yyyy",
                                                            )}
                                                          </CardLine>
                                                        </Box>
                                                        <Box flex={1}>
                                                          <Flex
                                                            gap="8"
                                                            alignItems={
                                                              "center"
                                                            }
                                                            mb={1}
                                                            fontSize={1}
                                                            color="gray.60"
                                                            fontFamily={
                                                              "'Inter', sans-serif"
                                                            }
                                                          >
                                                            {prevAddress?.country_flag && (
                                                              <Box
                                                                backgroundColor={
                                                                  "gray.10"
                                                                }
                                                                borderRadius={
                                                                  "50%"
                                                                }
                                                                p={"1"}
                                                              >
                                                                <img
                                                                  src={`data:image/png;base64,${prevAddress?.country_flag}`}
                                                                  alt="iamge"
                                                                />
                                                              </Box>
                                                            )}
                                                            {prevAddress?.country_flag && (
                                                              <span>
                                                                &nbsp;
                                                                {
                                                                  prevAddress?.country_name
                                                                }
                                                              </span>
                                                            )}
                                                          </Flex>
                                                        </Box>
                                                        <Box flex={1}>
                                                          {individual?.previous_address && (
                                                            <Box p={"1"}>
                                                              <CardLine>
                                                                {" "}
                                                                From &nbsp;
                                                                {
                                                                  individual
                                                                    ?.address
                                                                    ?.date_from
                                                                }
                                                                {individual
                                                                  ?.address
                                                                  ?.date_to && (
                                                                  <>
                                                                    &nbsp; to
                                                                    &nbsp;{" "}
                                                                    {
                                                                      individual
                                                                        ?.address
                                                                        ?.date_to
                                                                    }
                                                                  </>
                                                                )}
                                                              </CardLine>
                                                            </Box>
                                                          )}
                                                        </Box>
                                                        <Box flex={1}></Box>
                                                      </Flex>
                                                    </Box>
                                                  ),
                                                )}
                                              </>
                                            ) : (
                                              "-"
                                            )}
                                          </Box>
                                        )}
                                      </Box>
                                    </Flex>
                                    <Flex gap="24">
                                      {individual?.geo_location?.lat != null &&
                                        individual?.geo_location?.long !=
                                          null &&
                                        individual?.geo_location
                                          ?.location_service_permitted && (
                                          <>
                                            <Box flex={1}>
                                              <Heading>Geolocation</Heading>
                                              <Flex gap="24">
                                                <Box flex={1}>
                                                  <CardLine>Latitude</CardLine>
                                                  <CardLine>
                                                    {individual?.geo_location
                                                      ?.lat
                                                      ? individual?.geo_location
                                                          ?.lat
                                                      : "-"}
                                                  </CardLine>
                                                </Box>
                                                <Box flex={1}>
                                                  <CardLine>Longitude</CardLine>
                                                  <CardLine>
                                                    {individual?.geo_location
                                                      ?.long
                                                      ? individual?.geo_location
                                                          ?.long
                                                      : "-"}
                                                  </CardLine>
                                                </Box>
                                                <Box flex={1}>
                                                  <CardLine paddingLeft={"1"}>
                                                    Country
                                                  </CardLine>
                                                  <Flex
                                                    gap="8"
                                                    alignItems={"center"}
                                                    mb={1}
                                                    pl={"1"}
                                                    fontSize={1}
                                                    color="gray.60"
                                                    fontFamily={
                                                      "'Inter', sans-serif"
                                                    }
                                                  >
                                                    {individual?.geo_location
                                                      ?.country_flag ? (
                                                      <Box
                                                        backgroundColor={
                                                          "gray.10"
                                                        }
                                                        borderRadius={"50%"}
                                                        p={"1"}
                                                      >
                                                        <img
                                                          src={`data:image/png;base64,${individual?.geo_location?.country_flag}`}
                                                          alt="iamge"
                                                        />
                                                      </Box>
                                                    ) : (
                                                      "-"
                                                    )}
                                                    {individual?.geo_location
                                                      ?.country_flag && (
                                                      <span>
                                                        &nbsp;
                                                        {
                                                          individual
                                                            ?.geo_location
                                                            ?.country_name
                                                        }
                                                      </span>
                                                    )}
                                                  </Flex>
                                                </Box>
                                                <Box flex={1}></Box>
                                              </Flex>

                                              <br />
                                              <Box height="170px" flex={1}>
                                                <Geolocation
                                                  lat={
                                                    individual?.geo_location
                                                      ?.lat
                                                  }
                                                  long={
                                                    individual?.geo_location
                                                      ?.long
                                                  }
                                                />
                                              </Box>
                                            </Box>
                                          </>
                                        )}
                                    </Flex>
                                  </div>
                                ),
                              },
                              {
                                label: "Financials",
                                content: (
                                  <div>
                                    <Flex gap="24">
                                      {individual?.bank_account_detail ? (
                                        <Box flex={1.4}>
                                          <TitleHeading>
                                            Financial Details
                                          </TitleHeading>
                                          <h4 style={{ marginTop: "2%" }}>
                                            Bank Account
                                          </h4>
                                          {individual?.bank_account_detail ? (
                                            <Flex gap="24">
                                              <Box flex={1}>
                                                <CardLine mt={1}>
                                                  Name on account
                                                </CardLine>
                                                <CardLine color="gray.40">
                                                  {individual
                                                    ?.bank_account_detail
                                                    ?.account_name && (
                                                    <span>
                                                      {
                                                        individual
                                                          ?.bank_account_detail
                                                          ?.account_name
                                                      }
                                                      &nbsp;
                                                    </span>
                                                  )}
                                                </CardLine>
                                              </Box>
                                              <Box flex={1}>
                                                <CardLine mt={1}>
                                                  {individual
                                                    ?.bank_account_detail
                                                    ?.uk_account
                                                    ? " Sort code"
                                                    : "Swift/BIC code"}
                                                </CardLine>
                                                <CardLine color="gray.40">
                                                  {individual
                                                    ?.bank_account_detail
                                                    ?.sort_code && (
                                                    <span>
                                                      {
                                                        individual
                                                          ?.bank_account_detail
                                                          ?.sort_code
                                                      }
                                                      &nbsp;
                                                    </span>
                                                  )}
                                                  {individual
                                                    ?.bank_account_detail
                                                    ?.bank_bic && (
                                                    <span>
                                                      {
                                                        individual
                                                          ?.bank_account_detail
                                                          ?.bank_bic
                                                      }
                                                      &nbsp;
                                                    </span>
                                                  )}
                                                </CardLine>
                                              </Box>
                                              <Box flex={1}>
                                                <CardLine mt={1}>
                                                  Account number
                                                </CardLine>
                                                <CardLine color="gray.40">
                                                  {individual
                                                    ?.bank_account_detail
                                                    ?.account_number ? (
                                                    <span>
                                                      {
                                                        individual
                                                          ?.bank_account_detail
                                                          ?.account_number
                                                      }
                                                      &nbsp;
                                                    </span>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </CardLine>
                                              </Box>
                                              <Box flex={1}>
                                                <CardLine mt={1}>IBAN</CardLine>
                                                <CardLine color="gray.40">
                                                  {individual
                                                    ?.bank_account_detail
                                                    ?.iban ? (
                                                    <span>
                                                      {
                                                        individual
                                                          ?.bank_account_detail
                                                          ?.iban
                                                      }
                                                      &nbsp;
                                                    </span>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </CardLine>
                                              </Box>
                                            </Flex>
                                          ) : (
                                            "-"
                                          )}
                                        </Box>
                                      ) : (
                                        <Paragraph fontSize={1} color="gray.60" my={0}>
                                          This section is not included in your
                                          application process.
                                        </Paragraph>
                                      )}
                                    </Flex>
                                    <Box my={2}>
                                      <Employment
                                        employmentDetails={
                                          individual?.employment_detail
                                        }
                                      />
                                    </Box>
                                    <Box my={2}>
                                      <SourceOfFundsCard
                                        sourceOfFundsDetails={
                                          individual?.source_of_funds
                                        }
                                      />
                                    </Box>
                                  </div>
                                ),
                              },
                              {
                                label: "Forms",
                                content: (
                                  <ApplicationForms
                                    forms={individual?.forms}
                                    onRequestNew={() => setShowAddNewForm(true)}
                                  />
                                ),
                              },
                            ]}
                          />
  );
};
